import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import SingleFilter from './SingleFilter.js';
import TabFilterContent from './TabFilterContent.js';
import DateRange from '../date-range/DateRange.js';
import DateRangeYearOnly from '../date-range/DateRangeYearOnly.js';
import FieldsTree from '../fields-tree/FieldsTree.js';

const TabFilters = ({clang, allowedFilters, name, toggleFilters, applyFilter, setFilter, loadFilterByName, loadAllFiltersByName, expandTree, appliedFilters, openedFilter, setOpenedFilter, selectedFilters, isMobile}) => {
    const getComponent = (filter) => {
        let hideDefaultApply = false;
        let isDisabled = false;
        let component;

        const initialValuesFrom = filter.values !== null ? decodeURIComponent(filter.values[0]).split(';')[0] : '';
        const initialValuesTo = filter.values !== null ? decodeURIComponent(filter.values[0]).split(';')[1] : '';

        const initialValues = filter.values !== null ?
                                  {
                                      from: initialValuesFrom,
                                      to: initialValuesTo,
                                      fromBc: initialValuesFrom ? initialValuesFrom.indexOf('-') >= 0 : false,
                                      toBc: initialValuesTo ? initialValuesTo.indexOf('-') >= 0 : false,
                                  }
                                  : {
                                        from: filter.minValue ? filter.minValue.toString().replace('-', '') : '',
                                        to: filter.maxValue ? filter.maxValue.toString().replace('-', '') : '',
                                        fromBc: filter.minValue && filter.minValue.toString().indexOf('-') >= 0,
                                        toBc: filter.maxValue && filter.maxValue.toString().indexOf('-') >= 0,
                                    };

        const isSelected = appliedFilters.filter(filterItem => filterItem.id === filter.name && filterItem.value && filterItem.value.length > 0).length > 0;

        switch (filter.type) {
            case 'TREE_ID':
                isDisabled = filter.options && (!filter.options[0] || (!filter.options[0].children || (filter.options[0].children && filter.options[0].children.length < 1)));
                component = <FieldsTree fieldFilters={filter.options[0].children} setFilter={setFilter} expandTree={expandTree}/>;
                break;
            case 'ID':
            case 'FACETING_API':
                isDisabled = filter.options && filter.options.length < 1;
                component = <TabFilterContent {...filter} setFilter={setFilter} loadFilterByName={loadFilterByName} loadAllFiltersByName={loadAllFiltersByName}/>;
                break;
            case 'DATE':
                hideDefaultApply = true;
                isDisabled = !filter.minValue && !filter.maxValue;
                component = <DateRange
                                mask="99.99.9999"
                                form={filter.name}
                                isSelected={isSelected}
                                min={filter.minValue}
                                max={filter.maxValue}
                                setOpenedFilter={setOpenedFilter}
                                onSubmit={() => applyFilter(filter.name)}
                                initialValues={{...initialValues}}/>;
                break;
            case 'DATE_YEAR_ONLY':
                hideDefaultApply = true;
                isDisabled = !filter.minValue && !filter.maxValue;
                component = <DateRangeYearOnly
                                mask="9999"
                                form={filter.name}
                                setOpenedFilter={setOpenedFilter}
                                isSelected={isSelected}
                                min={filter.minValue}
                                max={filter.maxValue}
                                onSubmit={() => applyFilter(filter.name)}
                                initialValues={{...initialValues}}/>;
                break;
            default:
                break;
        }

        return <SingleFilter
                  {...filter}
                  key={filter.name}
                  id={filter.name}
                  options={filter.options}
                  isSelected={isSelected}
                  isDisabled={isDisabled && !filter.isFiltered}
                  hideDefaultApply={hideDefaultApply}
                  applyFilter={applyFilter}
                  componentData={component}
                  openedFilter={openedFilter}
                  selectedFilters={selectedFilters}
                  setOpenedFilter={setOpenedFilter}/>;
    };

    return (
        <div className={`results__tab-filters`}>
            {!isMobile && allowedFilters && allowedFilters.map(filter => getComponent(filter))}
            {isMobile &&
                <div className="results__tab-filters__opened">
                    <div className="results__tab-filters__opened__header">
                        <p className="results__tab-filters__opened__header-text">{lang[clang].results.filters}</p>
                        <button onClick={() => toggleFilters()} className="results__tab-filters__close" title={lang[clang].close}></button>
                    </div>
                    {allowedFilters &&
                        <div className="results__tab-filters__list">
                            {allowedFilters.map(filter => getComponent(filter))}
                        </div>}
                </div>}
        </div>
    );
};

TabFilters.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(TabFilters);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/TabFilters.js